import styled from 'styled-components'

export const PrivacyPoliciesContainer = styled.section`
  display: flex;
  flex-direction: column;
`

export const Content = styled.section`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
`

export const CheckboxAndButtonContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const CheckboxContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`

export const CheckboxContent = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`

export const PrivacyPolicyButtonContainer = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.5rem;
  border-bottom: 1px solid var(--gray200);
  width: 100%;
`

export const CustomCheckBoxContainer = styled.input`
  accent-color: var(--primary500);
`
